import { Component, OnInit } from '@angular/core';
import {UiService} from '../../services/ui.service';

@Component({
  standalone: false,
  selector: 'app-organizer',
  templateUrl: './organizer.component.html',
  styleUrls: ['./organizer.component.css']
})
export class OrganizerComponent implements OnInit {

  constructor(public uiService: UiService) { }

  ngOnInit(): void {
  }

}
